import { render } from "./BSSummary.vue?vue&type=template&id=379ead73&scoped=true"
import script from "./BSSummary.vue?vue&type=script&lang=js"
export * from "./BSSummary.vue?vue&type=script&lang=js"

import "./BSSummary.vue?vue&type=style&index=0&id=379ead73&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379ead73"]])

export default __exports__